
































































import Vue from "vue";
import Component from "vue-class-component";

import Page from "@/components/layout/Page.vue";
import Section from "@/components/layout/Section.vue";
import ServerDatatable from "@/components/collection/ServerDatatable.vue";
import Card from "@/components/layout/Card.vue";
import Row from "@/components/layout/Row.vue";
import Column from "@/components/layout/Column.vue";
import Container from "@/components/layout/Container.vue";
import IconButton from "@/components/basic/IconButton.vue";

import { MaterialRequestOverviewViewModel } from "@/store/vms/MaterialRequestOverviewViewModel";
import { MaterialRequestOverviewPresenter } from "@/store/presenters/MaterialRequestOverviewPresenter";
import { MaterialRequestOverviewController } from "@/store/controllers/MaterialRequestOverviewController";

import { AxiosGraphQLConnection } from "@/gateways/graphql/connections/AxiosGraphQLConnection";
import { AxiosLogger } from "@/logging/AxiosLogger";
import { ConsoleLogger } from "@/logging/ConsoleLogger";
import { MaterialRequestGraphQLService } from "../services/MaterialRequestGraphQLService";
import { StoreGraphQLService } from "../services/StoreGraphQLService";

@Component<MaterialRequestOverviewView>({
  components: {
    Page,
    Section,
    ServerDatatable,
    Card,
    Container,
    Column,
    Row,
    IconButton
  }
})
export default class MaterialRequestOverviewView extends Vue {
  private vm = new MaterialRequestOverviewViewModel();
  private controller?: MaterialRequestOverviewController;

  private initController(): MaterialRequestOverviewController {
    const connection = new AxiosGraphQLConnection(
      new AxiosLogger(new ConsoleLogger())
    );
    return new MaterialRequestOverviewController(
      new MaterialRequestOverviewPresenter(this.vm),
      new MaterialRequestGraphQLService(connection)
    );
  }

  private created() {
    this.controller = this.initController();
  }

  private mounted() {
    this.controller?.mounted();
  }

  private openMaterialRequest(item: any) {
    this.$router.push({
      name: "material-request",
      params: { materialRequestId: item.id }
    });
  }
}
